import React from "react";
import LoadingIcon from "./LoadingIcon";


function MainSection(props) {
    const excludeBg = props.excludeGridBg;

    console.log("excludeBg", excludeBg)
    console.log("props.excludeGridBg", props.excludeGridBg)

    return (
        <div className="main-section">
            {excludeBg ? null :
                <>
                    <div className="grid-bg" >
                        <div className="grid-image" />
                        <div className="grid-gradient-overlay" />
                    </div>
                    <div className="mobile-only-warning">
                        This webapp is not optimized for mobile. Please use a desktop browser for the best experience.
                    </div>
                </>
            }

            <div className="main-section-content">
                {props.children}
            </div>

        </div>
    )
}

// Just sets up the div. Assumes two children, first is title row.
function Section(props) {
    return (
        <div className="section">
            {props.children}
        </div>
    )
}

function SectionTitleRow(props) {
    return (
        <div className="section-title-row">
            {props.children}
        </div>

    )
}

function SectionTitle(props) {
    return (
        <div className="section-title-row">
            <div className="section-title">
                {props.title}
            </div>
        </div>
    )
}

function GrayCardTitle(props) {
    return (
        <div className="section-title-row">
            <div className="gray-section-title ">
                {props.title}
            </div>
        </div>
    )
}

function SurveyPageTitle(props) {
    return (
        <div className="session-title-row">
            <div className="session-title-text">
                All Responses
            </div>
            <div className="session-title-date">
                {props.completes} of {props.goal} completed
            </div>
        </div>
    )

}

function Card(props) {
    return (
        <div className="researcher-card" style={props.style}>
            {props.children}
        </div>
    )

}

function RightAlignedButton(props) {

    return (
        <div className="right-aligned-button">
            {props.children}
        </div>
    )
}

function MissionPageContainer(props) {
    return (
        <div className="mission-page-container">
            {props.children}
        </div>
    )
}

function SubCardContainer(props) {
    return (
        <div className="sub-card-container">
            {props.children}
        </div>
    )
}

function SubCard(props) {
    var className = "sub-card";
    if (props.pinkBorder) {
        className += " pink-border";
    }
    return (
        <div className={className} style={props.style}>
            {props.loading ? <div className="centered-loading"> <LoadingIcon /></div> : props.children}
        </div>
    )

}

function SubCardTitle(props) {
    return (
        <div className="sub-card-title">
            {props.children}
        </div>
    )
}

function SessionsContainer(props) {
    return (
        <div className="sessions-container">
            {props.children}
        </div>
    )

}

export {
    MainSection, Section, SectionTitle, SectionTitleRow, Card, GrayCardTitle, SurveyPageTitle,
    RightAlignedButton, MissionPageContainer, SubCardContainer, SubCard, SubCardTitle,
    SessionsContainer
};